import createReactComponent from '../createReactComponent';
export default createReactComponent('square-letter-y', 'IconSquareLetterY', [
  [
    'path',
    {
      d: 'M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M10 8l2 5l2 -5', key: 'svg-1' }],
  ['path', { d: 'M12 16v-3', key: 'svg-2' }],
]);
